import { useTheme } from '@mui/material';
import { lighten } from '@mui/material/styles';
import React from 'react';

import { Button } from '@ocx/ui';

export type SpireButtonProps = {
  label: string;
  onClick: () => void;
};

const LIGHTEN_COEFFICIENT = 0.15;

export const SpireButton = ({ label, onClick }: SpireButtonProps) => {
  const theme = useTheme();
  const { buttonGradientStart, buttonGradientEnd, buttonGradientContrastText } = theme.palette.Spire;

  return (
    <Button
      onClick={onClick}
      fullWidth
      sx={{
        background: `linear-gradient(90deg, ${buttonGradientStart}, ${buttonGradientEnd})`,
        color: buttonGradientContrastText,
        '&:hover': {
          background: `linear-gradient(90deg, ${lighten(buttonGradientStart, LIGHTEN_COEFFICIENT)}, ${lighten(
            buttonGradientEnd,
            LIGHTEN_COEFFICIENT,
          )})`,
        },
      }}>
      {label}
    </Button>
  );
};
